export default __webpack_public_path__ + "static/media/1949.10a17c79.png";